import React from "react";

const dreamCards = [
  {
    no: "01",
    title: "Zapis i interpretacja",
    text: "Każdy sen może zostać zapisany razem z odczytem, datą, nastrojem i własną notatką.",
  },
  {
    no: "02",
    title: "Powracające symbole",
    text: "Księga pozwala zobaczyć, które obrazy wracają najczęściej i jak zmieniają się w czasie.",
  },
  {
    no: "03",
    title: "Pytanie po analizie",
    text: "Po odczycie możesz zadać jedno dalsze pytanie, aby doprecyzować znaczenie snu bez rozbijania go na przypadkowe odpowiedzi.",
  },
];

const traceCards = [
  {
    title: "Powracające motywy",
    text: "Morfeusz wychwytuje wątki i obrazy, które wracają najczęściej.",
  },
  {
    title: "Emocje widoczne w czasie",
    text: "W Śladzie snów można zobaczyć, jak zmieniają się emocje między kolejnymi zapisami.",
  },
  {
    title: "Symbole, które wracają między snami",
    text: "Ślad łączy symbole w spokojniejszy kontekst i pokazuje ich powtarzalność.",
  },
  {
    title: "Osobna zgoda na budowanie Śladu",
    text: "Ślad snów powstaje tylko wtedy, gdy użytkownik wyrazi na to zgodę.",
  },
  {
    title: "Osobna zgoda na użycie Śladu w analizie AI",
    text: "Użytkownik decyduje, czy Morfeusz może wykorzystać Ślad jako kontekst kolejnych odczytów.",
  },
];

const processSteps = [
  {
    no: "01",
    title: "Opisz sen",
    text: "Zapisz obraz, nastrój, osoby i szczegóły, które zostały po przebudzeniu.",
  },
  {
    no: "02",
    title: "Wybierz odczyt",
    text: "Skorzystaj z analizy AI, Jung lub Freud. Wybierz tryb Szybki albo Głęboki.",
  },
  {
    no: "03",
    title: "Zadaj jedno pytanie",
    text: "Po analizie możesz doprecyzować sens snu jednym pytaniem, bez rozbijania odczytu na przypadkowy dialog.",
  },
  {
    no: "04",
    title: "Wracaj do Śladu",
    text: "Z czasem Morfeusz pokazuje powracające motywy, emocje i symbole — jeśli użytkownik zgodzi się budować Ślad snów.",
  },
];

const faqLeft = [
  "Czy darmowy odczyt zapisuje mój sen?",
  "Czy moje sny są publiczne?",
  "Jak działa analiza snów?",
  "Czym jest Sejf?",
];

const faqRight = [
  "Co jeśli zapomnę hasła?",
  "Dlaczego sesja może się zamknąć?",
  "Czym jest Ślad snów?",
  "Czy interpretacja zastępuje diagnozę albo terapię?",
];

export function HomePageVariant() {
  return (
    <main data-ui="home-v3">
      <section data-ui="home-v3-hero">
        <div data-ui="home-v3-shell">
          <div data-ui="home-v3-hero-inner">
            <div data-ui="home-v3-overline">SENNA WYROCZNIA · EST. MMXXVI</div>
            <h1 data-ui="home-v3-title">Zinterpretuj <span>swój sen</span></h1>
            <p data-ui="home-v3-lead">
              Powierz nocne wizje cyfrowemu Morfeuszowi. Otrzymasz odczyt symboliki,
              archetypów i ukrytych nurtów psychiki — pisany językiem starych ksiąg.
            </p>
            <div data-ui="home-v3-divider" />
            <div data-ui="home-v3-dream-box">
              <div data-ui="home-v3-dream-hint">
                Opisz sen jak najwierniej... Co widziałeś? Kto był obecny? Jaki towarzyszył nastrój?
              </div>
              <div data-ui="home-v3-dream-meta">
                <span>Anonimowo · bez rejestracji</span>
                <span>interpretacja w kilka sekund</span>
              </div>
              <div data-ui="home-v3-dream-actions">
                <button type="button" data-ui="home-v3-primary-btn">ZINTERPRETUJ SEN</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section data-ui="home-v3-section">
        <div data-ui="home-v3-shell">
          <div data-ui="home-v3-section-head">
            <div>
              <div data-ui="home-v3-label">KSIĘGA SNÓW</div>
              <h2 data-ui="home-v3-heading">Miejsce, do którego wracają Twoje sny</h2>
            </div>
            <p data-ui="home-v3-body">
              Morfeusz nie kończy pracy na jednym odczycie. Sny tworzą prywatną kronikę:
              zapisy, interpretacje, symbole, notatki i bezpieczną przestrzeń dla tego, co naprawdę osobiste.
            </p>
          </div>
          <div data-ui="home-v3-ksiega-grid">
            <div data-ui="home-v3-dream-cards">
              {dreamCards.map((item) => (
                <article key={item.no} data-ui="home-v3-card">
                  <div data-ui="home-v3-card-no">{item.no}</div>
                  <h3 data-ui="home-v3-card-title">{item.title}</h3>
                  <p data-ui="home-v3-card-text">{item.text}</p>
                </article>
              ))}
            </div>
            <aside data-ui="home-v3-book-preview">
              <div data-ui="home-v3-book-paper">
                <div data-ui="home-v3-book-kicker">PODGLĄD KSIĘGI</div>
                <h3 data-ui="home-v3-book-title">Dom nad wodą</h3>
                <div data-ui="home-v3-book-subtitle">Ostatni sen · zapis roboczy</div>
                <p data-ui="home-v3-book-text">
                  Stałem przed domem, którego drzwi prowadziły prosto do ciemnej, spokojnej wody.
                  W środku paliło się jedno światło.
                </p>
                <div data-ui="home-v3-book-divider" />
                <div data-ui="home-v3-book-kicker">ODCZYT WSTĘPNY</div>
                <p data-ui="home-v3-book-text">
                  Sen wskazuje na próg między bezpiecznym miejscem a głęboką emocją, która domaga się spokojnego rozpoznania.
                </p>
                <div data-ui="home-v3-book-meta">
                  <span>Nastrój: cichy niepokój</span>
                  <span>Sejf: pod kluczem</span>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section data-ui="home-v3-section">
        <div data-ui="home-v3-shell">
          <div data-ui="home-v3-vault">
            <div data-ui="home-v3-vault-visual"><div data-ui="home-v3-vault-box" /><div data-ui="home-v3-vault-key" /></div>
            <div data-ui="home-v3-vault-copy">
              <div data-ui="home-v3-label">SEJF</div>
              <h2 data-ui="home-v3-heading">Dodatkowy klucz dla wszystkich osobistych snów</h2>
              <p data-ui="home-v3-body">
                Sejf chroni Księgę Snów. Jest integralną warstwą dla wpisów i notatek,
                które użytkownik chce zamknąć mocno — nikt tu nie zagląda.
              </p>
              <div data-ui="home-v3-vault-note">
                Sejf jest Pokoikiem, Pokoik Sejfem — prywatna Księga otwiera się tylko wtedy,
                gdy Morfeusz rozpoznaje właściciela.
              </div>
              <div data-ui="home-v3-vault-features">
                <div data-ui="home-v3-vault-feature">Nie blokuje zakładania konta</div>
                <div data-ui="home-v3-vault-feature">Chroni prywatne sny i notatki</div>
                <div data-ui="home-v3-vault-feature">Otwiera się jednym spójnym rytmem sesji</div>
                <div data-ui="home-v3-vault-feature">Zostaje częścią Pokoiku Morfeusza</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section data-ui="home-v3-section">
        <div data-ui="home-v3-shell">
          <div data-ui="home-v3-section-head">
            <div>
              <div data-ui="home-v3-label">ŚLAD SNÓW</div>
              <h2 data-ui="home-v3-heading">To, co powraca pod powierzchnią</h2>
            </div>
            <p data-ui="home-v3-body">
              Nie każdy sen jest osobną wyspą. Morfeusz może budować zaszyfrowany Ślad snów:
              wyciąg z powracających motywów, emocji i symboli, bez zamieniania pełnej treści snu w profil.
            </p>
          </div>
          <div data-ui="home-v3-trace-grid">
            {traceCards.map((item, index) => (
              <article key={item.title} data-ui={index < 3 ? "home-v3-trace-card-top" : "home-v3-trace-card-bottom"}>
                <h3 data-ui="home-v3-card-title">{item.title}</h3>
                <p data-ui="home-v3-card-text">{item.text}</p>
              </article>
            ))}
          </div>
          <div data-ui="home-v3-trace-footer">
            To użytkownik decyduje, czy Morfeusz ma budować Ślad snów i czy wolno użyć go jako kontekstu do kolejnych odczytów.
          </div>
        </div>
      </section>

      <section data-ui="home-v3-section">
        <div data-ui="home-v3-shell">
          <div data-ui="home-v3-process">
            <h2 data-ui="home-v3-heading-center">Jak sen trafia do Morfeusza</h2>
            <div data-ui="home-v3-divider" />
            <div data-ui="home-v3-process-grid">
              {processSteps.map((item) => (
                <article key={item.no} data-ui="home-v3-process-step">
                  <div data-ui="home-v3-process-no">{item.no}</div>
                  <h3 data-ui="home-v3-process-title">{item.title}</h3>
                  <p data-ui="home-v3-process-text">{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section data-ui="home-v3-section">
        <div data-ui="home-v3-shell">
          <div data-ui="home-v3-symbols">
            <div data-ui="home-v3-symbols-copy">
              <div data-ui="home-v3-label">ATLAS SYMBOLI</div>
              <h2 data-ui="home-v3-heading">Znaki, które wracają w snach</h2>
              <p data-ui="home-v3-body">
                Symbolika Morfeusza nie jest martwą listą haseł. Gdy symbol nie ma jeszcze znaczenia w bibliotece,
                Morfeusz odczytuje go z kontekstu i dopisuje do rosnącego atlasu nocnych obrazów.
              </p>
            </div>
            <div data-ui="home-v3-symbols-form">
              <div data-ui="home-v3-symbols-kicker">ODCZYTAJ JEDEN SYMBOL ZE SNU</div>
              <p data-ui="home-v3-symbols-sub">
                Gościnnie: 1 prosty symbol dziennie. W Księdze Snów odczytujesz symbole z kontekstem.
              </p>
              <input data-ui="home-v3-input" type="text" placeholder="np. woda, dom, klucz..." readOnly />
              <div data-ui="home-v3-symbols-actions">
                <button type="button" data-ui="home-v3-primary-btn">ODCZYTAJ SYMBOL</button>
                <button type="button" data-ui="home-v3-secondary-btn">PEŁNA SYMBOLIKA</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section data-ui="home-v3-section">
        <div data-ui="home-v3-shell">
          <div data-ui="home-v3-room">
            <div data-ui="home-v3-room-visual" />
            <div data-ui="home-v3-room-copy">
              <div data-ui="home-v3-label">PRYWATNY POKOIK</div>
              <h2 data-ui="home-v3-heading">Twoje miejsce po przebudzeniu</h2>
              <p data-ui="home-v3-body">
                Po zalogowaniu Morfeusz prowadzi do Pokoiku — spokojnego miejsca, z którego wracasz do snów,
                dodajesz nowe wpisy, sprawdzasz Ślad snów i stan sejfu.
              </p>
              <div data-ui="home-v3-room-list">
                <div>Szybki zapis snu, zanim obraz odpłynie</div>
                <div>Dodawanie i edycja snów w Księdze</div>
                <div>Analizy AI, Jung i Freud</div>
                <div>Symbolika i Ślad snów</div>
                <div>Profil, avatar i ustawienia prywatności</div>
                <div>Instalacja Morfeusza jako aplikacji</div>
              </div>
            </div>
            <div data-ui="home-v3-room-cta">
              <button type="button" data-ui="home-v3-primary-btn">ZAŁÓŻ KONTO</button>
              <p data-ui="home-v3-room-note">
                Konto jest bezpłatne. Pakiety i płatności będą porządkowane osobno, gdy przyjdzie czas na sklep Morfeusza.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section data-ui="home-v3-section" data-ui-block="faq">
        <div data-ui="home-v3-shell">
          <div data-ui="home-v3-faq-wrap">
            <div data-ui="home-v3-label">FAQ</div>
            <div data-ui="home-v3-faq-grid">
              <div data-ui="home-v3-faq-col">
                {faqLeft.map((item) => <div key={item} data-ui="home-v3-faq-item"><span>{item}</span><span>⌄</span></div>)}
              </div>
              <div data-ui="home-v3-faq-col">
                {faqRight.map((item) => <div key={item} data-ui="home-v3-faq-item"><span>{item}</span><span>⌄</span></div>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
